'use strict';

/**
 * CookiePopup
 *
 * @author Rico Schmidt <rico.schmidt@namics.com>
 */
T.Module.CookiePopup = T.createModule({

	_names: {
		cookie: 'cookiepopup',
		hiddenCookie: 'hide'
	},

	_selectors: {
		button: '.a-button'
	},

	_stateClasses: {
		visible: 'state-visible'
	},

	start: function start(resolve) {
		// References
		this.$ctx = $(this._ctx);

		if (!this._checkCookieExists()) {
			this.$button = this.$ctx.find(this._selectors.button);
			this.$button.click(this.handleButtonClick.bind(this));
		}
		// Lifecycle Callback
		resolve();
	},
	_checkCookieExists: function _checkCookieExists() {
		var cookieCookie = window.Cookies.get(this._names.cookie);
		if (typeof cookieCookie === 'undefined') {
			this.$ctx.addClass(this._stateClasses.visible);
			return false;
		}
		this.$ctx.remove();
		return true;
	},
	handleButtonClick: function handleButtonClick() {
		window.Cookies.set(this._names.cookie, this._names.hiddenCookie, {
			expires: 180,
			path: '/'
		});
		this.$ctx.remove();
	},
	sync: function sync() {}
});